import { InsuranceAccordionConfiguration, InsuranceStepConfiguration } from '../types';
import {
  SET_VENDOR_OPPORTUNITY,
  SET_CREDIT_APPLICATION,
  SET_SUBMISSIONS,
  SET_PROPOSALS,
  SET_FINANCE_PROGRAMS,
  SET_SELECTED_SUBMISSION,
  SET_SELECTED_FINANCE_PROGRAM,
  SET_STEPPER_CONFIG,
  SET_ACCORDION_CONFIG,
  UPDATE_STEPPER_CONFIG,
  UPDATE_ACCORDION_CONFIG,
  SET_INSURANCE_BROKER,
  SET_INSURANCE_VERIFICATION_TASK,
  SET_INSURANCE_CERTIFICATE,
  SET_COVERAGE_STATUS_CONFIG,
  CLEAR_STATE,
} from './actionTypes';

const setVendorOpportunity = (payload: any) => ({
  type: SET_VENDOR_OPPORTUNITY,
  payload,
});

const setCreditApplication = (payload: any) => ({
  type: SET_CREDIT_APPLICATION,
  payload,
});

const setSubmissions = (payload: any[]) => ({
  type: SET_SUBMISSIONS,
  payload,
});

const setProposals = (payload: any[]) => ({
  type: SET_PROPOSALS,
  payload,
});

const setFinancePrograms = (payload: any[]) => ({
  type: SET_FINANCE_PROGRAMS,
  payload,
});

const setSelectedSubmission = (payload: any) => ({
  type: SET_SELECTED_SUBMISSION,
  payload,
});

const setSelectedFinanceProgram = (payload: any) => ({
  type: SET_SELECTED_FINANCE_PROGRAM,
  payload,
});

const setStepperConfig = (payload: any) => ({
  type: SET_STEPPER_CONFIG,
  payload,
});

const setAccordionConfig = (payload: any) => ({
  type: SET_ACCORDION_CONFIG,
  payload,
});

const updateStepperConfig = (payload: { idx: number; config: Partial<InsuranceStepConfiguration> }) => ({
  type: UPDATE_STEPPER_CONFIG,
  payload,
});

const updateAccordionConfig = (payload: { idx: number; config: Partial<InsuranceAccordionConfiguration> }) => ({
  type: UPDATE_ACCORDION_CONFIG,
  payload,
});

const setInsuranceBroker = (payload: any) => ({
  type: SET_INSURANCE_BROKER,
  payload,
});

const setInsuranceVerificationTask = (payload: any) => ({
  type: SET_INSURANCE_VERIFICATION_TASK,
  payload,
});

const setInsuranceCertificate = (payload: any) => ({
  type: SET_INSURANCE_CERTIFICATE,
  payload,
});

const setCoverageStatusConfig = (payload: any) => ({
  type: SET_COVERAGE_STATUS_CONFIG,
  payload,
});

const clearState = () => ({ type: CLEAR_STATE });

export const insuranceActions = {
  setVendorOpportunity,
  setCreditApplication,
  setSubmissions,
  setProposals,
  setFinancePrograms,
  setSelectedSubmission,
  setSelectedFinanceProgram,
  setStepperConfig,
  setAccordionConfig,
  updateStepperConfig,
  updateAccordionConfig,
  setInsuranceBroker,
  setInsuranceVerificationTask,
  setInsuranceCertificate,
  setCoverageStatusConfig,
  clearState,
};
